const authStoreTypes = {
  mutations: {
    SET_ACCESS_TOKEN: 'SET_ACCESS_TOKEN',
    SET_USERINFORMATION: 'SET_USERINFORMATION'
  },
  actions: {
    HANDLE_APP_CALLBACK_LOGIN: 'HANDLE_APP_CALLBACK_LOGIN',
    DECODE_JWT: 'DECODE_JWT'
  },
  getters: {
    LAST_VISITED_DATE: 'LAST_VISITED_DATE',
    USER_IS_DOCTOR: 'USER_IS_DOCTOR'
  }
};

export default authStoreTypes;
